import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types';
import { IActionEditorState } from '.';

const actionEditor = (state: RootState) => state.actionEditor;

export const selectActionEditor = createSelector([actionEditor], (actionEditor: IActionEditorState) => {
  return actionEditor;
});
